import { IAdminNotification } from '@care-portals/api-interfaces';
import { createAction, props } from '@ngrx/store';

export const loadNotifications = createAction(
  '[Notification] Load Notifications'
);

export const loadNotificationsSuccess = createAction(
  '[Notification] Load Notifications Success',
  props<{ notifications: IAdminNotification[] }>()
);

export const loadNotificationsFailure = createAction(
  '[Notification] Load Notifications Failure',
  props<{ error: any }>()
);

export const dismissAll = createAction(
  '[Notification] Mark All Notification As Read'
);

export const dismissAllSuccess = createAction(
  '[Notification] Mark All Notification As Read Success'
);

export const dismissAllFailure = createAction(
  '[Notification] Mark All Notification As Read Failure',
  props<{ error: any }>()
);

export const dismissSingle = createAction(
  '[Notification] Mark Notification As Read',
  props<{ notificationId: string }>()
);

export const dismissSingleSuccess = createAction(
  '[Notification] Mark Notification As Read Success',
  props<{ notificationId: string }>()
);

export const dismissSingleFailure = createAction(
  '[Notification] Mark Notification As Read Failure',
  props<{ error: any }>()
);
